import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, ThemeProvider } from '@mui/material';
import MaterialTable from 'material-table';
import api from '../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import tableTheme from '../../components/Theme';
import FabButton from '../../components/Buttons/FabButton';
import Table from '../../components/Table';

function Workers() {
  const [workers, setWorkers] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [exportData, setExportData] = useState([]);

  const columns = [
    {
      title: 'Funcionário',
      field: 'name',
      type: 'string',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => rowData.name,
    },
    {
      title: 'Cargo',
      field: 'post',
      type: 'string',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => rowData.post,
    },
    // {
    //     title: 'Regime',
    //     field: 'date',
    //     type: 'date',
    //     hideFilterIcon: true,
    //     editable: 'never',
    //     dateSetting: { locale: 'pt-BR' },
    // },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/workers');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setWorkers(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    workers.map((worker) => (worker.id === newData.id
      ? tempData.push(newData)
      : tempData.push(worker)));
    setWorkers(tempData);
  }

  // const handleClick = (id) => {
  //
  //     history.push("/worker/" + id)
  // }

  return (
    <Table
      title="Funcionários"
      route="/workers/"
      routeAdd="/worker/"
      columns={columns}
      data={workers}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default Workers;
